import type { SelectOption } from '@components/Select/select.types';
import type { TFunction } from 'i18next';

export type ReportSortColumn = {
  id: string;
  apiId: string;
  labelKey: string;
};

export const REPORTS_SORT_COLUMNS: ReportSortColumn[] = [
  { id: 'specie', apiId: 'specie', labelKey: 'reports.columns.species' },
  {
    id: 'etiologicalData',
    apiId: 'etiologicalAgentCode',
    labelKey: 'reports.columns.disease',
  },
  {
    id: 'populationSize',
    apiId: 'populationSize',
    labelKey: 'reports.columns.individualsAffected',
  },
  {
    id: 'createdAt',
    apiId: 'detectionDate',
    labelKey: 'reports.columns.dateOfDetection',
  },
  {
    id: 'countryCode',
    apiId: 'countryCode',
    labelKey: 'reports.columns.location',
  },
  { id: 'status', apiId: 'status', labelKey: 'reports.columns.status' },
];

export const REPORTS_SORT_KEY_MAP = REPORTS_SORT_COLUMNS.reduce<
  Record<string, string>
>((accumulator, column) => {
  accumulator[column.id] = column.apiId;
  return accumulator;
}, {});

export const getReportSortOptions = (t: TFunction): SelectOption[] => [
  { value: '', label: t('reports.sort.none') },
  ...REPORTS_SORT_COLUMNS.map((column) => ({
    value: column.id,
    label: t(column.labelKey),
  })),
];
